import { Tag } from "antd";

import { Department } from "@app/models/User.ts";
import { colorByDepartmentId } from "@app/services/utils/userUtils.ts";

interface CmtDepartmentFieldProps {
  department: Department | undefined;
}

export const CmtDepartmentField = ({ department }: CmtDepartmentFieldProps) => {
  return (
    department && (
      <Tag color={colorByDepartmentId[department.id] || "gray"}>
        {department.name}
      </Tag>
    )
  );
};
